module.exports = __webpack_public_path__ + "static/media/qr-play-google-com.fe4e5984.png";